import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  TextField,
} from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import { useTranslation } from "react-i18next";
import { WorkerService } from "src/services";



 
const Documents = (props) => {
  const { t } = useTranslation();
  const { touched, errors, values, handleBlur, handleChange ,disabled} = props;

  let passportValidityDate = values.baseFields?.passportValidityDate ? values.baseFields?.passportValidityDate.substring(0, 10) : '';
  let driversLicenceValidityDate = values.baseFields?.driversLicenceValidityDate ? values.baseFields?.driversLicenceValidityDate.substring(0, 10) : '';
  let residencePermitValidityDate = values.baseFields?.residencePermitValidityDate ? values.baseFields?.residencePermitValidityDate.substring(0, 10) : '';

  return (
    <div id="cover" style={ disabled?{pointerEvents:'none',opacity:0.7}:null}>
    <Card>
      <CardHeader title={t("pages.workerregister.documents.stepname")} />
      <Divider />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label={t("worker.citizenServiceNumber")}
              name="baseFields.citizenServiceNumber"
              error={Boolean(
                touched.baseFields?.citizenServiceNumber &&
                  errors.baseFields?.citizenServiceNumber
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.citizenServiceNumber}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="baseFields.hasAnyCar"
                  color="primary"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.baseFields?.hasAnyCar}
                  checked={values.baseFields?.hasAnyCar}
                />
              }
              label={t("worker.hasAnyCar")}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="baseFields.hasAnyHealthInsurance"
                  color="primary"
                  onBlur={handleBlur}
                  onChange=
                  {event => 
                     {
                       handleChange(event)  ;
                       if (!event.target.checked) {
                         props.setFieldValue('baseFields.healthInsuranceDetail','')
                       }                              
                     }
                  } 
                  value={values.baseFields?.hasAnyHealthInsurance}
                  checked={values.baseFields?.hasAnyHealthInsurance}
                />
              }
              label={t("worker.hasAnyHealthInsurance")}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              disabled ={!values.baseFields?.hasAnyHealthInsurance}
              InputLabelProps={{ shrink: true }}
              label={t("worker.healthInsuranceDetail")}
              name="baseFields.healthInsuranceDetail"
              error={Boolean(
                touched.baseFields?.healthInsuranceDetail &&
                  errors.baseFields?.healthInsuranceDetail
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.healthInsuranceDetail}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label={t("worker.bankOfPayment")}
              name="baseFields.bankOfPayment"
              error={Boolean(
                touched.baseFields?.bankOfPayment &&
                  errors.baseFields?.bankOfPayment
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.bankOfPayment}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label={t("worker.bankAccountNumberOfPayment")}
              name="baseFields.bankAccountNumberOfPayment"
              error={Boolean(
                touched.baseFields?.bankAccountNumberOfPayment &&
                  errors.baseFields?.bankAccountNumberOfPayment
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.bankAccountNumberOfPayment}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label={t("worker.passportNumber")}
              name="baseFields.passportNumber"
              error={Boolean(
                touched.baseFields?.passportNumber &&
                  errors.baseFields?.passportNumber
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.passportNumber}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField fullWidth 
              label={t("worker.passportValidityDate")}
              type="date"
              name="baseFields.passportValidityDate"
              InputLabelProps={{ shrink: true, }}
              error={Boolean(touched.baseFields?.passportValidityDate && errors.baseFields?.passportValidityDate)}
              onBlur={handleBlur}
              onChange={handleChange}
              value={passportValidityDate} />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label={t("worker.driversLicenceNumber")}
              name="baseFields.driversLicenceNumber"
              error={Boolean(
                touched.baseFields?.driversLicenceNumber &&
                  errors.baseFields?.driversLicenceNumber
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.driversLicenceNumber}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField fullWidth
              label={t("worker.driversLicenceValidityDate")}
              type="date"
              name="baseFields.driversLicenceValidityDate"
              InputLabelProps={{ shrink: true, }}
              error={Boolean(touched.baseFields?.driversLicenceValidityDate && errors.baseFields?.driversLicenceValidityDate)}
              onBlur={handleBlur}
              onChange={handleChange}
              value={driversLicenceValidityDate} />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label={t("worker.residencePermit")}
              name="baseFields.residencePermit"
              error={Boolean(
                touched.baseFields?.residencePermit &&
                  errors.baseFields?.residencePermit
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.residencePermit}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField fullWidth
              label={t("worker.residencePermitValidityDate")}
              type="date"
              name="baseFields.residencePermitValidityDate"
              InputLabelProps={{ shrink: true, }}
              error={Boolean(touched.baseFields?.residencePermitValidityDate && errors.baseFields?.residencePermitValidityDate)}
              onBlur={handleBlur}
              onChange={handleChange}
              value={residencePermitValidityDate} />
          </Grid>
          <Grid item md={12} xs={12}>
            <DropzoneArea 
              dropzoneText={"Drag and drop an Passport image here or click"}
              onChange={(files) => {
                if (files && files.length > 0) {
                  WorkerService.UPLOAD_FILE(files[0], files[0].name)
                    .then((response) => {
                      const {message} = response.data;
                      props.setFieldValue("baseFields.passportImagePath", message);
                    })
                    .catch((err) => {
                      console.log("file-err", err);
                    });
                } 
              }}
              onDelete={(files) => { 
                props.setFieldValue("baseFields.passportImagePath", undefined); 
              }}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="baseFields.hasDiplomaBasicSafetyVca"
                  color="primary"
                  onBlur={handleBlur}
                  onChange= {event => 
                    {
                      handleChange(event)  ;
                      if (!event.target.checked) {
                        props.setFieldValue('baseFields.diplomaBasicSafetyVcanumber','')
                      }                              
                    }
                 } 
                  value={values.baseFields?.hasDiplomaBasicSafetyVca}
                  checked={values.baseFields?.hasDiplomaBasicSafetyVca}
                />
              }
              label={t("worker.hasDiplomaBasicSafetyVca")}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label={t("worker.diplomaBasicSafetyVcanumber")}
              name="baseFields.diplomaBasicSafetyVcanumber"
              error={Boolean(
                touched.baseFields?.diplomaBasicSafetyVcanumber &&
                  errors.baseFields?.diplomaBasicSafetyVcanumber
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.diplomaBasicSafetyVcanumber}
              disabled ={!values.baseFields?.hasDiplomaBasicSafetyVca}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="baseFields.hasSafetyPassport"
                  color="primary"
                  onBlur={handleBlur}
                  onChange= {event => 
                    {
                      handleChange(event)  ;
                      if (!event.target.checked) {
                        props.setFieldValue('baseFields.safetyPassportNumber','')
                      }                              
                    }
                 } 
                  value={values.baseFields?.hasSafetyPassport}
                  checked={values.baseFields?.hasSafetyPassport}
                />
              }
              label={t("worker.hasSafetyPassport")}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              label={t("worker.safetyPassportNumber")}
              name="baseFields.safetyPassportNumber"
              error={Boolean(
                touched.baseFields?.safetyPassportNumber &&
                  errors.baseFields?.safetyPassportNumber
              )}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.baseFields?.safetyPassportNumber}
              disabled={!values.baseFields?.hasSafetyPassport}
            />
          </Grid>
        </Grid>
      </CardContent>
      <>
        {/* Master state
        <pre>{JSON.stringify(props.values, null, 2)}</pre> */}
      </>
    </Card>
   </div>
  );
};

export default Documents;
